import { Component, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

export type AlertVariant = 'success' | 'warning' | 'danger' | 'info';

@Component({
  selector: 'htx-alert',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  host: {
    '[class.alert-container]': 'true'
  }
})
export class AlertComponent {
  /**
   * The variant/type of alert
   */
  variant = input<AlertVariant>('info');

  /**
   * The title/heading of the alert
   */
  title = input<string>('');

  /**
   * The message content of the alert
   */
  message = input<string>('');

  /**
   * Show close button
   */
  closable = input<boolean>(false);

  /**
   * Event emitted before the alert is closed (optional callback for cleanup)
   */
  beforeClose = output<void>();

  /**
   * Internal visibility state
   */
  isVisible = signal(true);

  /**
   * Get the icon name based on variant
   */
  getIcon() {
    const iconMap: { [key in AlertVariant]: string } = {
      success: 'check_circle',
      warning: 'warning',
      danger: 'error',
      info: 'info'
    };
    return iconMap[this.variant()];
  }

  /**
   * Handle close button click
   */
  onClose(): void {
    this.beforeClose.emit();
    this.isVisible.set(false);
  }
}
